module.exports = __webpack_public_path__ + "img/back_length_to_waist.1fcd014a.png";